declare global {
  // eslint-disable-next-line no-var
  var __DEV__: boolean;
}

if (typeof globalThis !== 'undefined') {
  globalThis.__DEV__ = import.meta.env.MODE === 'development';
}
